import { useEffect, useState } from 'react'
import { getTextsFromBrowser } from '@/lib/i18n/index'
import type { ITranslations } from '@/lib/i18n/index'

export function useTextsFromBrowser(): ITranslations | null {
  const [texts, setTexts] = useState<ITranslations | null>(null)

  useEffect(() => {
    setTexts(getTextsFromBrowser(navigator.language))
  }, [])

  return texts
}
